<template>
  <v-row>
    <v-col v-if="!hideBackBtn" cols="2">
      <BackBtn class="pb-2 text-left" />
    </v-col>
    <v-spacer v-if="!$vuetify.breakpoint.xsOnly"></v-spacer>
    <v-col v-if="!hideSearchBar">
      <v-text-field
        v-model="search"
        rounded dense
        prepend-inner-icon="search"
        @keydown.enter="setValue()"
        label="Search"
        ref="search"
        :append-icon="`${search ? 'close' : ''}`"
        @click:append="setNull()"
        single-line
        outlined
        hide-details
      />
    </v-col>

    <v-col v-if="!hideSearchBar" class="shrink">
      <v-btn color="primary" dark @click="setValue()">Search</v-btn>
    </v-col>
  </v-row>
  <!-- <v-layout row class="mb-3">
    <v-flex> </v-flex>
    <v-spacer></v-spacer>
    <v-flex
      v-if="!hideSearchBar"
      align-self-center
      xs12
      sm3
      :class="{ 'offset-sm8': hideBackBtn }"
    >
    </v-flex>
    <v-flex v-if="!hideSearchBar" shrink>
      <v-btn color="primary" dark @click="setValue()">Search</v-btn>
    </v-flex>
  </v-layout> -->
</template>

<script>
export default {
  props: ['hideBackBtn', 'hideSearchBar'],
  data() {
    return {
      search: null,
    };
  },
  created() {
    setTimeout(() => {
      if (this.$refs['search']) {
        this.$refs['search'].$refs.input.focus();
      }
    }, 200);
  },
  methods: {
    setValue() {
      this.$emit('input', this.search);
    },
    setNull() {
      this.$emit('input', '');
      this.search = '';
    },
  },
};
</script>

<style scoped>
</style>
